<template>
  <!-- 课表组件 -->
  <div v-loading="loading">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconPro.png" alt="" />
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>当月排班</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="exportClass">
      <div class="allClass">
        <div class="morning">早班</div>
        <span class="time">09:00-17:30</span>
        <div class="night">晚班</div>
        <span class="time">11:00-20:00</span>
        <div class="rest">休息</div>
        <span class="time">全天</span>
        <div class="rest_day">日/休</div>
        <span class="time">9:00-14:00</span>
        <div class="day_rest">休/日</div>
        <span class="time">13:00-17:30</span>
        <div class="time_rest">时间段</div>
        <span class="time">时间区间</span>
      </div>

      <div class="exportData" @click="exportMethod">导出数据</div>
    </div>
    <div class="class-table">
      <div class="table-wrapper">
        <div class="tabel-container">
          <table id="tableExcel">
            <thead>
              <tr>
                <th v-for="(item, index) in classTableData.monthScheduleTitle" :key="index">
                  <p>{{ item.substring(5, 10) }}</p>
                  <p>{{ item.substring(10, 14) }}</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- restActive -->
              <tr v-for="(item, index) in classTableData.course" :key="index">
                <td class="table-td">{{ item.doctorName }}</td>
                <td v-for="(innerItem, idx) in item.doctorSchedule" :key="idx">
                  <div v-if="innerItem.workStatus&&innerItem.workStatus == '时间段'">
                    <el-popover popper-class="whatBox" placement="top-start" trigger="hover">
                      <div v-for="(ele,index) in innerItem.timeSlot" :key="index">
                        <span>{{ele}}</span>
                      </div>
                      <div slot="reference">
                        <div class="iconActive">{{ innerItem.workStatus }}</div>
                      </div>
                    </el-popover>
                  </div>
                  <div v-if="innerItem.workStatus&&innerItem.workStatus!= '时间段'" :class="
                      innerItem.workStatus == '晚班'? 'nightActive': innerItem.workStatus == '早班'? 'morActive'
                      :innerItem.workStatus == '日/休'? 'timeActive': innerItem.workStatus == '休/日'? 'dayRestAcitve':innerItem.workStatus == '时间段'? 'iconActive':'restActive'">
                    {{ innerItem.workStatus }}
                  </div>
                  <!-- <div v-else>休息</div> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <el-pagination style="float:right;" @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      classTableData: {
        weeks: [],
        courses: [],
      },
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
      },
      active: "",
      loading: false,
      cityCode: Lockr.get('cityCode'),
    };
  },
  computed: {},
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page;
      this.refresh();
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes;
      this.refresh();
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({},
          this.$route.query, {
            __query: JSON.stringify(this.pagination),
          }, {
            random: Math.random(),
          }
        ),
      });
    },
    // 查询数据列表
    query() {
      var querys = {
        scheduleMonth: "",
        page: this.filters.pagination.page,
        size: this.filters.pagination.limit,
        cityCode: this.cityCode
      };
      api.requestQuiet("/doctor/findMonthSchedulePage", querys, (res) => {
        // console.log(res);
        this.classTableData = res.data;
        this.classTableData.course = res.data.pageList.list;
        this.classTableData.course.forEach(item => {
          item.doctorSchedule.forEach(ele => {
            if (ele.timeSlot) {
              ele.timeSlot = ele.timeSlot.split(',')
              // console.log(ele.timeSlot);
            }
          });
        });
        this.filters.pagination.total = parseInt(res.data.pageList.total);
      }, (err) => { });
    },
    exportMethod() {
      let exportUrl = axios.defaults.baseURL;
      console.log("exportUrl");
      console.log(exportUrl);
      var formData = new FormData();
      formData.append("cityCode", this.cityCode)
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "doctor/excelDoctorSchedule", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "当月排班.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.cityCode == 'null' || this.cityCode == null) {
      this.cityCode = ''
    }
  },
  mounted() {
    /*this.init();*/
    this.query();
  },
  watch: {
    $route(to, from) {
      this.query();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.table-wrapper {
  width: 100%;
  overflow: auto;
}

table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  color: #677998;
  border: 1px solid #eceae7;
}

thead {
  /* background: #d4f7fd; */
  font-size: 14px;
  border: 1px solid #eceae7;
}

th {
  font-weight: normal;
  height: 46px !important;
  width: 50px !important;
}

tbody {
  font-size: 12px;
}

th,
td {
  text-align: center;
}

tr {
  border-bottom: 1px solid #eaeaea;
}

tr td div {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

tr td:first-child {
  color: #333;
  position: relative;
}

.course {
  background-color: #ebbbbb;
  color: #fff;
  display: inline-block;
  border-radius: 3px;
  width: 47%;
  margin: 1px 1%;
}

.table-td {
  font-size: 12px;
  word-wrap: break-word;
  word-break: break-all;
  height: 46px !important;
  position: fixed;
  left: 0;
  /* border: 1px solid red; */
}

.night {
  width: 56px;
  height: 56px;
  background: #eff6ff;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #262626;
  text-align: center;
  line-height: 56px;
  color: #155bd4;
}

.morning {
  width: 56px;
  height: 56px;
  background: #fff9ec;
  border-radius: 8px;
  text-align: center;
  line-height: 56px;
  color: #f9a800;
}

.rest {
  width: 56px;
  height: 56px;
  background: #e7e7e7;
  border-radius: 8px;
  text-align: center;
  line-height: 56px;
  color: #888888;
}

.allClass {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 48px;
}

.nightActive {
  width: 45px;
  height: 25px;
  background: #eff6ff;
  border-radius: 8px;
  color: #155bd4;
  line-height: 25px;
  cursor: pointer;
}

.morActive {
  width: 45px;
  height: 25px;
  background: #fff9ec;
  border-radius: 8px;
  color: #f9a800;
  line-height: 25px;
  cursor: pointer;
}

.restActive {
  width: 45px;
  height: 25px;
  background: #e7e7e7;
  border-radius: 8px;
  color: #888888;
  line-height: 25px;
  cursor: pointer;
}

.timeActive {
  width: 45px;
  height: 25px;
  background: #b8e4c3;
  border-radius: 8px;
  color: #16853b;
  line-height: 25px;
  cursor: pointer;
}

.dayRestAcitve {
  width: 45px;
  height: 25px;
  background: #eed3e5;
  border-radius: 8px;
  color: #f55bc1;
  line-height: 25px;
  cursor: pointer;
}

.iconActive {
  width: 45px;
  height: 25px;
  background: #bcc78f;
  border-radius: 8px;
  color: #888888;
  line-height: 25px;
  cursor: pointer;
}

.rest_day {
  background: #b8e4c3;
  border-radius: 8px;
  color: #16853b;
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
}
.day_rest {
  background: #eed3e5;
  border-radius: 8px;
  color: #f55bc1;
  line-height: 25px;
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
}
.time_rest {
  background: #bcc78f;
  border-radius: 8px;
  color: #888888;
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
}

.time {
  margin: 0 10px;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}

.exportData {
  width: 125px;
  height: 38px;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  background: #fdab55;
}

.exportClass {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
</style>
<style >
.whatBox {
  min-width: 100px !important;
  width: 100px !important;
}
</style>